<template>
  <div class="item-wrapper" v-if="item">
    <div class="top">
      <div class="preview-container">
        <div class="bundle">
          <ImageGrid :images="imagePaths" :imgDomain="imgDomain" />

          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="info__table">
              <div class="info-key">Image amount:</div>
              <div class="info-value">{{ item.items.length }}</div>
              <div class="info-key">Description:</div>
              <div v-html="item.description" class="info-value"></div>
            </div>
          </div>

          <div class="actions">
            <div class="price">
              <div class="price__key">Original price:</div>
              <div class="price__value">{{ item.price_original }} {{ currency }}</div>
              <div class="price__key">Bundle price:</div>
              <div class="price__value bold">{{ item.price }} {{ currency }}</div>
            </div>

            <router-link :to="{name: 'Bundle', params: {id: item.id}}" class="button blue view-btn">
              View
            </router-link>
          </div>
        </div>
      </div>
    </div>
<!--    <div :class="['bottom', {'bottom-doc': item.product_type !== 'image'}, {'member': item.members_only == 1}]" @click="goToSliderItem(item)">-->
<!--      <div class="title">{{ item.title }}</div>-->
<!--      <div class="buy">-->
<!--        <div class="price title">-->
<!--          <div>{{ $t('Price') }}:</div>-->
<!--          <span>{{ item.price }} <span class="currency">{{ currency }}</span></span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>


<script>
import ImageGrid from './ImageGrid.vue';

export default {
  name: 'ImageBundle',
  components: {
    ImageGrid
  },
  props: ['item', 'sliderIsClickble', 'currency', 'isAuth', 'lazy', 'categories'],
  data() {
    return {
      imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
      tag: ''
    }
  },
  computed: {
    imagePaths() {
      return this.item.items.map(image => image.doc_url);
    }
  },
  methods: {
    getCornerClass(index, total) {
      const side = Math.sqrt(total);
      if (!Number.isInteger(side)) return '';

      if (index === 0) return 'top-left';
      if (index === side - 1) return 'top-right';
      if (index === total - side) return 'bottom-left';
      if (index === total - 1) return 'bottom-right';
      return '';
    },
    openReadyModal() {
      this.$emit('openReadyModal');
    },
    isNumber(variable) {
      return Number.isFinite(variable) && typeof variable === "number";
    },
    goToSliderItem(item) {
      setTimeout(() => {
        if (this.sliderIsClickble === true) {
          this.$emit('goToProduct', item);
        }
      }, 200)
    },
    getPack() {
      if (this.isAuth) {
        this.openReadyModal();
      } else {
        this.openSignInModal();
      }
    },
    openSignInModal() {
      this.$emit('openSignInModal');
    },
    openBuyModal(item, type) {
      this.$emit('openBuyModal', item, type)
    }
  },
}
</script>


<style lang="scss">
.images-wrapper {
  overflow: hidden;
  border-radius: 8px;
  width: 288px;
  height: 288px;
  aspect-ratio: 1 / 1; /* контейнер всегда квадратный */
  background: #f7f7f7; /* можно добавить серый фон для красоты */
}

.images {
  display: grid;
  //width: 288px;
  //height: 288px;
  //gap: 2px;
}

.images.grid-1 {
  grid-template-columns: repeat(1, 1fr);
}
.images.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}
.images.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}
.images.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}
.images.grid-5 {
  grid-template-columns: repeat(5, 1fr);
}
.images.grid-6 {
  grid-template-columns: repeat(6, 1fr);
}

.images img {
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1; /* Квадратная форма */
  object-fit: cover;
  display: block;
}

/* Скругляем углы только крайним картинкам */
.top-left {
  border-top-left-radius: 8px;
}

.top-right {
  border-top-right-radius: 8px;
}

.bottom-left {
  border-bottom-left-radius: 8px;
}

.bottom-right {
  border-bottom-right-radius: 8px;
}
</style>

